import { motion } from "framer-motion";
import { PORTFOLIO } from "@/data/site";
import { Reveal } from "@/components/motion/Reveal";

export const Portfolio = () => {
  return (
    <section id="portfolio" className="section bg-[#0A0A0A] border-t border-[#27272A]">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-20">
          <Reveal>
            <div>
              <div className="text-xs uppercase tracking-[0.4em] text-accent mb-4">/ 02 The Work</div>
              <h2 className="font-display text-5xl sm:text-7xl text-white leading-none" data-testid="portfolio-title">
                RECENT
                <br />
                CUTS.
              </h2>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-dim max-w-md text-base">
              Every fade, every line, every shape — straight from the chair. This is
              what walks out of Blendz.Jay's station.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[260px]">
          <PortfolioCard item={PORTFOLIO[0]} index={0} className="md:row-span-2 md:h-full" />
          <PortfolioCard item={PORTFOLIO[1]} index={1} className="md:col-span-2" />
          <PortfolioCard item={PORTFOLIO[2]} index={2} />
          <PortfolioCard item={PORTFOLIO[3]} index={3} />
          <PortfolioCard item={PORTFOLIO[4]} index={4} className="md:col-span-2" />
          <PortfolioCard item={PORTFOLIO[5]} index={5} />
          <PortfolioCard item={PORTFOLIO[6]} index={6} />
        </div>
      </div>
    </section>
  );
};

const PortfolioCard = ({ item, className = "", index = 0 }) => {
  if (!item) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30, scale: 0.98 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.9, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className={`relative overflow-hidden rounded-md group ${className}`}
      data-testid={`portfolio-item-${item.alt.replace(/\s+/g, '-').toLowerCase()}`}
    >
      <motion.img
        src={item.url}
        alt={item.alt}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover"
        whileHover={{ scale: 1.08 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/0 to-black/0 opacity-100 group-hover:opacity-80 transition-opacity" />
      <div className="absolute inset-x-0 bottom-0 p-5 overflow-hidden">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 + index * 0.08, duration: 0.6 }}
          className="text-xs uppercase tracking-[0.3em] text-white/90"
        >
          <span className="text-accent mr-2">0{index + 1}</span>
          {item.alt}
        </motion.div>
      </div>
    </motion.div>
  );
};
